// The workspace @spotted-zebra-uk/ui-components package is served
// un-prebundled from dist/esm in Vite dev, where the config's
// `define: { 'process.env.NODE_ENV': ... }` shim does NOT apply (define only
// rewrites source at build/prebundle time). Some bundled deps (react-tooltip's
// dropdown-menu path, @carbon/*) read process.env at runtime, so give dev a
// real global. Production builds still rely on `define`; there this is a
// harmless no-op. Must be the FIRST import of the entry so it evaluates
// before the ui-components module graph.
globalThis.process ??= { env: {} } as NodeJS.Process;

export {};
